export default __webpack_public_path__ + "static/media/download_button.b3a02d89.png";